import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, FreeMode } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';

import star from '../../../assets/assets-homepage/img/icons/Star3.svg';
import usr1 from '../../../assets/assets-homepage/img/usr1.webp';
import usr2 from '../../../assets/assets-homepage/img/usr2.webp';
import usr3 from '../../../assets/assets-homepage/img/usr3.webp';
import usr6 from '../../../assets/assets-homepage/img/usr6.webp';
import usr7 from '../../../assets/assets-homepage/img/usr7.webp';
import usr8 from '../../../assets/assets-homepage/img/usr8.webp';
 import quote from '../../../assets/assets-homepage/img/icons/quote.svg';

const FeedbackSlider = () => {
  const { t } = useTranslation('home');
  const { t: tCommon } = useTranslation('common');
  const testimonials = [
    { id: 1, textKey: 'feedback.testimonials.t1', nameKey: 'feedback.names.t1', image: usr1 },
    { id: 2, textKey: 'feedback.testimonials.t2', nameKey: 'feedback.names.t2', image: usr2 },
    { id: 3, textKey: 'feedback.testimonials.t3', nameKey: 'feedback.names.t3', image: usr3 },
    { id: 6, textKey: 'feedback.testimonials.t6', nameKey: 'feedback.names.t6', image: usr6 },
    { id: 7, textKey: 'feedback.testimonials.t7', nameKey: 'feedback.names.t7', image: usr7 },
    { id: 8, textKey: 'feedback.testimonials.t8', nameKey: 'feedback.names.t8', image: usr8 },
  ];

  return (
    <>
      <Swiper
        spaceBetween={20}
        freeMode={true}
        speed={2000}
        loop={true}
        modules={[FreeMode, Autoplay, Pagination]}
        autoplay={{
          delay: 1000,
          disableOnInteraction: false
        }}
        pagination={{
          el: '.feedback_pagination',
          clickable: true
        }}
        breakpoints={{
          0: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 12,
            autoplay: false,
            freeMode: true,
            speed: 400
          },
          640: {
            slidesPerView: 'auto',
            spaceBetween: 20,
            centeredSlides: true
          },
          992: {
            centeredSlides: false,
            spaceBetween: 20,
            slidesPerView: 2
          },
          1380: {
            slidesPerView: 3,
            loopAdditionalSlides: 1
          }
        }}
        onSlideChange={(swiper: any) => {
          if (swiper.isBeginning || swiper.isEnd) {
            swiper.loopFix();
          }
        }}
        className="feedback_slider"
      >
        {testimonials.map((testimonial) => (
          <SwiperSlide key={testimonial.id}>
            <div className="feedback_item">
              <div className="feedback_item__top">
                <img src={quote} alt={tCommon('alt.quote')} />
                <p>{t(testimonial.textKey)}</p>
              </div>

              <div className="feedback_item__bottom">
                <div className="feedback_item__user">
                  <div className="feedback_item__img">
                    <img src={testimonial.image} alt={t(testimonial.nameKey)} />
                  </div>

                  <div className="feedback_item__user_info font-inter">
                    <div className="feedback_item__rating flex items-center space-x-1">
                      {[...Array(5)].map((_, i) => (
                        <img key={i} src={star} alt={tCommon('alt.star')} />
                      ))}
                    </div>
                    <span>{t(testimonial.nameKey)}</span>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="pagination feedback_pagination"></div>
    </>
  );
};

export default FeedbackSlider;